import { Routes, Route } from 'react-router-dom';
import Main from '../page/main/Main';
import Sodamap from '../page/sodamap/Sodamap';
import Gallery from '../page/gallery/Gallery';
import SodamapTest from '../page/sodamap_test/SodamapTest';
import Board from '../page/board/Board';
import ViewPost from '../page/board/view_post/ViewPost';
import CreatePost from '../page/board/create_post/CreatePost';
import KhsTempPage from '../page/khs_temp_page/khs_temp';
import ModeSelect from '../page/lab/lab_1/mode_select/ModeSelect';
import PointData from 'page/lab/lab_1/point_data/PointData';
import HousingInfoPage from 'page/lab/lab_2/housing_info/housingInfo';
import PopulationInfoPage from 'page/lab/lab_2/population_info/populationInfo';
import LifestylePage from 'page/lab/lab_2/lifestyle/lifestyle';
import Signup from 'page/user/Signup';
import Login from 'page/user/Login';
import ProtectedRoute from './ProtectedRoute';
import UserDataPage from 'page/my_map/user_data/UserDataPage';
import GeoCoderPage from 'page/my_map/geocoder';
import LabMapsPage from 'page/lab/lab_2/maps';
import LabUserDataRedirect from 'page/lab/lab_2/user_data/UserDataRedirect';
import { Navigate } from 'react-router-dom';
import Amount from 'page/lab/lab_1/amount/Amount';

export const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Main />} />
            <Route path="/sodamap" element={<Sodamap />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/test/map" element={<SodamapTest />} />
            <Route path="/test/board" element={<Board />} />
            <Route path="/test/board/:boardIndex" element={<Board />} />
            <Route path="/test/board/:boardIndex/:postIndex" element={<ViewPost />} />
            <Route path="/test/board/writepost" element={<CreatePost />} />
            <Route path="/test/board/writepost/:boardIndex" element={<CreatePost />} />
            <Route path="/test/khs_temp" element={<KhsTempPage />} />

            <Route path="/my_map/user_data" element={
                <ProtectedRoute>
                    <UserDataPage />
                </ProtectedRoute>
            } />
            <Route path="/my_map/geocoder" element={
                <ProtectedRoute>
                    <GeoCoderPage />
                </ProtectedRoute>
            } />

            <Route path="/lab/lab_1/mode_select" element={<ModeSelect />} />
            <Route path="/lab/lab_1/point_data" element={<PointData />} />
            <Route path="/lab/lab_1/amount" element={<Amount />} />
            

            <Route
                path="/lab/lab_2/*"
                element={
                    <ProtectedRoute>
                        <Routes>
                            <Route path="maps" element={<Navigate to="maps/population" replace />} />
                            <Route path="maps/:tab" element={<LabMapsPage />} />
                            <Route path="housing_info" element={<HousingInfoPage />} />
                            <Route path="population_info" element={<PopulationInfoPage />} />
                            <Route path="lifestyle" element={<LifestylePage />} />
                            <Route path="user_data" element={<LabUserDataRedirect />} />
                        </Routes>
                    </ProtectedRoute>
                }
            />

            <Route path="/user/signup" element={<Signup />} />
            <Route path="/user/login" element={<Login />} />
        </Routes>
    );
};
